<div>
  <div class="d-flex">
    <h3>
      Clients
      @if (!loading) { <span>({{ clients.length | number: '' }})</span> }
    </h3>

    @if (canManageClients) {
      <a class="btn btn-primary ms-md-auto"
         routerLink="/capture-admin/client-management/clients/new">
        Add New Client
      </a>
    }
  </div>

  @if (!loading) {
    <app-client-list
      [clients]="clients"
      [canManageClients]="canManageClients"
      [canManageClientConfigurations]="canManageClientConfigurations" />
  } @else {
    <mat-spinner diameter="30" />
  }
</div>
